import { render, staticRenderFns } from "./footer-modals.vue?vue&type=template&id=404147a3&"
import script from "./footer-modals.vue?vue&type=script&lang=js&"
export * from "./footer-modals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports